import { render, staticRenderFns } from "./dus-lib-items.vue?vue&type=template&id=38f51c5e&"
import script from "./dus-lib-items.vue?vue&type=script&lang=js&"
export * from "./dus-lib-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports